import StarterKit from "@tiptap/starter-kit";
import Text from "@tiptap/extension-text";
import Document from "@tiptap/extension-document";
import { Link } from "@tiptap/extension-link";
import { TaskList, TaskItem } from "@tiptap/extension-list";
import TextAlign from "@tiptap/extension-text-align";
import { TextStyle, FontSize, LineHeight, Color } from "@tiptap/extension-text-style";

const OneLineDocument = Document.extend({
  content: "text*"
});

export const minimalExtensions = [OneLineDocument, Text];
export const fullExtensions = [
  StarterKit.configure({
    // Disable the default link extension
    link: false
  }),
  Link.configure({
    openOnClick: true,
    autolink: true,
    linkOnPaste: true
  }),
  TaskList,
  TaskItem,
  TextAlign.configure({
    types: ['heading', 'paragraph'],
    alignments: ["start", "center", "end"],
    defaultAlignment: "start"
  }),
  TextStyle,
  FontSize,
  LineHeight,
  Color,
];
